'use client';

import React, { useCallback, useEffect, useState } from 'react';

import useBlockScroll from '@/hooks/useBlockScroll';

import Link from '@/components/ui/link';

import NavigationMenu from '@/components/header/navigation-menu';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const openNavigationMenu = () => {
    setIsMenuOpen(true);
  };
  const closeNavigationMenu = useCallback(() => {
    setIsMenuOpen(false);
  }, []);

  useBlockScroll(isMenuOpen);

  useEffect(() => {
    const handleEscapeKey = (e) => {
      if (e.key === 'Escape' && isMenuOpen) {
        closeNavigationMenu();
      }
    };

    window.addEventListener('keydown', handleEscapeKey);
    return () => window.removeEventListener('keydown', handleEscapeKey);
  }, [isMenuOpen, closeNavigationMenu]);

  return (
    <div className="relative top-0 z-10 flex w-full items-center justify-between px-[5%] pt-4">
      <Link
        prefetch={true}
        href="/"
        className="text-lg leading-5 uppercase md:text-xl"
      >
        Piyush <br />
        Gambhir
      </Link>
      <button
        onClick={openNavigationMenu}
        className="text-lg leading-5 uppercase md:text-xl"
      >
        Menu
      </button>
      {isMenuOpen && (
        <NavigationMenu closeNavigationMenu={closeNavigationMenu} />
      )}
    </div>
  );
}
